import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store'
import JQuery from 'jquery'
window.$ = JQuery;

import VueSocketIO from 'vue-socket.io'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueInputAutowidth from 'vue-input-autowidth'
import FontPicker from 'font-picker-vue';
require('vue2-animate/dist/vue2-animate.min.css')
import VueAnalytics from 'vue-analytics'

Vue.use(FontPicker);
Vue.use(VueYouTubeEmbed);
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
Vue.use(VueInputAutowidth);
import Sticky from 'vue-sticky-directive'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
Vue.directive('Sticky', Sticky);
import VueFreezeframe from 'vue-freezeframe';

Vue.use(VueFreezeframe);
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);
import VueCarousel from 'vue-carousel';
Vue.component('vue-draggable-resizable', VueDraggableResizable);
Vue.use(VueCarousel);
Vue.use(new VueSocketIO({
  debug: true,
  connection: 'https://hihat.io:3000'
}));

Vue.use(VueAnalytics, {
  id: 'UA-137144876-1',
  router
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
